import React from 'react';
import { Modal } from 'antd';
import s from './s.module.less';
import commonS from 'styles/common.module.less';
import UploadReviewsSelectPanel from './components/UploadReviewsSelectPanel';

type Props = {
    show: boolean;
    onCannel?: () => void;
    onClickDirectUpload?: () => void;
    onClickManualInput?: () => void;
};

const UploadReviewsOverviewModal = (props: Props) => {
    const { show, onClickDirectUpload, onCannel, onClickManualInput } = props;

    return (
        <Modal
            title="Upload reviews"
            closable
            className={commonS.modalFixHeightWrap}
            width="650px"
            onCancel={() => {
                onCannel?.();
            }}
            footer={null}
            open={show}
            destroyOnClose
        >
            <div className={s.wrap}>
                <UploadReviewsSelectPanel
                    onClickDirectUpload={onClickDirectUpload}
                    onClickManualInput={onClickManualInput}
                />
            </div>
        </Modal>
    );
};

export default UploadReviewsOverviewModal;

